import { useContext } from "react";

import PopUpContext from "../context/popUpContext";

const usePopUp = () => {
    const { message, setMessage } = useContext(PopUpContext);
    return { message, setMessage };
};

export default usePopUp;
